/**
 * Created by Allan on 2021/04/25.
 * Contact 84880528@qq.com.
 */
import Frame from '@/layouts/Frame'
export default[
    {
        path:'/order',
        meta:{
            title:'订单管理',
            icon:'el-icon-s-order',
            menuId:'1'
        },
        component:Frame,
        children:[
            {
                path:'index',
                name:'orderList',
                meta:{
                    title:'订单列表',
                    keepAlive:true,
                    menuId:'3'
                },
                component:resolve => require(['@/views/order/list/index'], resolve)
            },
            {
                path:'details/:userId',
                name:'orderDetails',
                meta:{
                    title:'订单详情',
                },
                hidden:true,
                component:resolve => require(['@/views/order/details/index'], resolve)
            },
        ],
    }
]



// WEBPACK FOOTER //
// ./src/router/map/order.js